module.exports = __webpack_public_path__ + "static/media/Feb6-S20.fa55792b.png";